import React, { useState } from 'react'
import { motion } from 'framer-motion';
import { EmptyHomework } from '../empty-homework/empty-homework';
import { AddHomeworkCard } from '../add-homework-card/add-homework-card';
import { HomeworkCard } from '../homework-card/homework-card';
import { PastLessonsFeed } from '../past-lessons-feed/past-lessons-feed';
import { useMaterialsFeed } from '@entities/appointment/api/useMaterialsFeed';
import { itemVariants, listVariants } from '@widgets/appointment/lib/appointment-animation';

export const Homeworks = ({isTeacher, appointment, appointmentId}) => {
	const [isHiddenEmptyHomework, setIsHiddenEmptyHomework] = useState(false);
	const feed = useMaterialsFeed(appointmentId, 'homework');
	const homework = feed.currentLesson?.homework ?? appointment?.homework ?? [];
	
	return (
		<motion.div
				key="homework-mode"
				initial="hidden"
				animate="visible"
				exit={{ opacity: 0, y: -10 }}
				variants={listVariants}
				style={{width: '100%'}}
			>
				{!homework?.length && !isHiddenEmptyHomework ? (
					<motion.div variants={itemVariants} style={{width: '100%'}}>
						<EmptyHomework onClick={() => setIsHiddenEmptyHomework(true)} />
					</motion.div>
				) : (
					<>
						{isTeacher ? (
							<motion.div variants={itemVariants} style={{width: '100%'}}>
								<AddHomeworkCard appointmentId={appointmentId} startExpanded={isHiddenEmptyHomework} />
							</motion.div>
						) : (
							""
						)}
						{homework?.map((homework, index, list) => {
							const previousHomework = list[index - 1];
							const previousAuthorId = previousHomework?.user_id || previousHomework?.user?.id;
							const currentAuthorId = homework?.user_id || homework?.user?.id;
							const showAuthorInfo = index === 0 || String(previousAuthorId) !== String(currentAuthorId);

							return (
							<motion.div key={`homework-${homework?.id}`} variants={itemVariants} style={{width: '100%'}}>
								<HomeworkCard {...{ homework, appointmentId, appointment, isTeacher, showAuthorInfo }} />
							</motion.div>
							);
						})}
					</>
				)}
				<PastLessonsFeed
					pastLessons={feed.pastLessons}
					hasMore={feed.hasMore}
					isFetchingPast={feed.isFetchingPast}
					onLoadMore={feed.loadMore}
					kind="homework"
					appointment={appointment}
					isTeacher={isTeacher}
				/>
			</motion.div>
	)
}
